import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Optional } from '@angular/core';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { CheckoutFormComponent } from './checkout-form.component';
import { CheckoutMinibasketComponent } from './checkout-minibasket.component';

@Component({
    selector: 'checkout-minibasket-modal',
    templateUrl: './checkout-minibasket-modal.html',
    standalone: true,
    imports: [CommonModule, CheckoutMinibasketComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutMinibasketModalComponent {
    constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        @Optional() protected modalRef: ModalRef<CheckoutMinibasketModalComponent>,
        @Optional() @Inject(MODAL_DATA) public checkoutFormComponent: CheckoutFormComponent
    ) {}

    close = (): void => {
        this.modalRef?.close();
    };
}
